import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App.jsx';

import './styles/tokens.css';
import './styles/reset.css';
import './styles/typography.css';
import './styles/motion.css';
import './styles/utilities.css';

const container = document.getElementById('root');

const tree = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Every route is prerendered, so in production there is real markup to
// hydrate. `vite dev` serves the bare template, so fall back to a fresh
// render there rather than warning about a mismatch against an empty root.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
